import { Box, useTheme } from "@mui/material";
import { useParams } from "react-router";

import { PageLayout } from "@/shared/components";

import { Profile } from "./Profile";

export function User() {
  const theme = useTheme();
  const { userId } = useParams<{ userId: string }>();
  return (
    <PageLayout
      title={`Roboto - Profile - ${userId}`}
      headerContentLeft={"Profile"}
    >
      <Box
        sx={{
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
        }}
      >
        <Profile userId={userId} />
      </Box>
    </PageLayout>
  );
}
